module.exports = __webpack_public_path__ + "asset/image/utility-on-d86a.svg";